import { createContext, useContext, useState, useEffect } from 'react';

// Lead form data interface
export const LeadFormData = {
    goals: [],
    email: '',
    firstName: '',
    lastName: '',
    company: '',
    phone: '',
    experiments: [],
};

const LeadDataContext = createContext({
    leadData: null,
    setLeadData: data => {},
    consumeLeadData: () => {},
});

// localStorage key for lead data backup
const LEAD_DATA_KEY = 'ica_lead_data';

export const LeadDataProvider = ({ children }) => {
    const [leadData, setLeadDataState] = useState(null);

    // Load lead data from localStorage on mount
    useEffect(() => {
        const storedData = localStorage.getItem(LEAD_DATA_KEY);
        if (storedData) {
            try {
                const parsed = JSON.parse(storedData);
                setLeadDataState(parsed);
            } catch (e) {
                // Invalid data, ignore
            }
        }
    }, []);

    // Save lead data to localStorage when it changes
    useEffect(() => {
        if (leadData) {
            localStorage.setItem(LEAD_DATA_KEY, JSON.stringify(leadData));
        } else {
            localStorage.removeItem(LEAD_DATA_KEY);
        }
    }, [leadData]);

    const setLeadData = data => {
        setLeadDataState(data);
    };

    const consumeLeadData = () => {
        setLeadDataState(null);
    };

    const value = {
        leadData,
        setLeadData,
        consumeLeadData,
    };

    return <LeadDataContext.Provider value={value}>{children}</LeadDataContext.Provider>;
};

export const useLeadData = () => {
    const context = useContext(LeadDataContext);
    if (!context) {
        throw new Error('useLeadData must be used within LeadDataProvider');
    }
    return context;
};
